<template>
    <div class="lang">
        <div class="info">
            <div class="table">
                <table>
                    <caption>Шинжилгээний  хариу (Visit consultation, Postal consultation, View internet result)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">Төв дээр ирэх</th>
                            <td class="left">
                                Захиалсан өдөр цагтаа төв дээр ирж хариуцсан эмчтэй уулзан шинжилгээний хариуны талаар ярилцан зөвлөгөө авах боломжтой. <br>
                                Зөвлөгч эмч шинжилгээний хариуг харгалзан үзлэг эмчилгээ хийх тасагт захиалга өгч үйлчилнэ.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Шинжилгээний хариуг шуудангаар авах</th>
                            <td class="left">
                                Шинжилгээний хариуг шуудангаар авахаар захиалсан бол захиалга өгсөн тухайн өдөр хариуг илгээнэ. Нийтийн амралтын өдрөөс бусад өдөр 3 хоногийн дотор хариугаа авах боломжтой. <br>
                                Хариуг илгээхийн өмнө төвийн сувилагч утсаар холбогдон нэмэлт эмчилгээ үйлчилгээ шаардлагатай бол амбулаторийн тасагт хэрхэн цаг захиалах тухай зааварлана
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Шинжилгээний хариуг интернэтээр авах</th>
                            <td class="left">
                                Шинжилгээний хариуг интернэтээр авах бол зөвлөгөө авахаар захиалга өгсөн өдрөөс хойш И-Хуа их сургуулийн Сөүл салбар эмнэлгийн Велнес Эрүүл мэндийг дэмжих төвийн цахим хуудсанд нэвтэрсний(бүртгүүлсний) дараа “Миний хуудас” цэсний [Хариуг харах] булан руу орж үзнэ.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="botton-wrap">
                <a href="/" class="main-button c-main" target="_blank">Шинжилгээний хариу харах<i class="icon-link01"></i></a>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>